import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import TransactionService from "services/TransactionService";

export const initialState = {
  data: [],
  dataDetail: [],
  loading: false,
  batchLoading: false,
  batchProgress: null, // { loaded, total, currentPage, totalPages }
  error: null,
  redirect: false,
};

export const fetchTransactionData = createAsyncThunk(
  "transaction/fetchTransactionData",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, startDate, endDate, outlet, type, status, invoice } = data;
      const response = await TransactionService.get({
        page,
        pageSize,
        sort,
        startDate,
        endDate,
        outlet,
        type,
        status,
        invoice,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchAllTransactionData = createAsyncThunk(
  "transaction/fetchAllTransactionData",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { sort, startDate, endDate, outlet, type, status, invoice, batchSize = 1000 } = data;
      const allData = await TransactionService.getAll({
        sort,
        startDate,
        endDate,
        outlet,
        type,
        status,
        invoice,
        batchSize,
        onBatchLoaded: (progress) => {
          dispatch(updateBatchProgress(progress));
        },
      });
      return { data: allData };
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchTransactionDetail = createAsyncThunk(
  "transaction/fetchTransactionDetail",
  async (inv, { rejectWithValue }) => {
    try {
      const response = await TransactionService.getDetail(inv);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    updateBatchProgress: (state, action) => {
      state.batchProgress = action.payload;
      // Update data progressively so table shows partial results
      state.data = { data: action.payload.data };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactionData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(fetchTransactionData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchTransactionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAllTransactionData.pending, (state) => {
        state.batchLoading = true;
        state.batchProgress = null;
        state.error = null;
      })
      .addCase(fetchAllTransactionData.fulfilled, (state, action) => {
        state.batchLoading = false;
        state.batchProgress = null;
        state.data = action.payload;
      })
      .addCase(fetchAllTransactionData.rejected, (state, action) => {
        state.batchLoading = false;
        state.batchProgress = null;
        state.error = action.payload;
      })
      .addCase(fetchTransactionDetail.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(fetchTransactionDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDetail = action.payload.data?.data[0];
      })
      .addCase(fetchTransactionDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export const { showLoading, updateBatchProgress } = transactionSlice.actions;

export default transactionSlice.reducer;
